import axios from '@/request/http'
import global from '@/constants/Global.constants'
import moment from 'moment/moment';
import md5 from 'js-md5';
import { encryptDes } from '@/utils/des'
export async function redirectEncrypt (url) {
    // 1. 构造完整的 URL 字符串（以你的代码为例）
    const fullUrl = url;

    // 2. 获取 ? 前的地址
    const questionMarkIndex = fullUrl.indexOf('?');
    let baseUrl = fullUrl;
    let queryString = '';

    if (questionMarkIndex !== -1) {
    baseUrl = fullUrl.substring(0, questionMarkIndex);
    queryString = fullUrl.substring(questionMarkIndex + 1);
    }

    // 3. 将查询参数转换为 JSON 对象
    function parseQueryToJson(queryStr) {
    if (!queryStr) return {};
    const params = new URLSearchParams(queryStr);
    const json = {};
    for (const [key, value] of params.entries()) {
        json[key] = value;
    }
    return json;
    }

    let paramsJson = parseQueryToJson(queryString);
    console.log('redirectEncrypt',baseUrl,paramsJson)
    
    let time = moment(new Date()).format('yyyyMMDDHHmmss')
    let sign = md5(`${paramsJson.token}_${time}`)
    let ets = encryptDes(time,'yyhs2025')
    console.log(time,sign,ets,'加密')
    let formData = new FormData()
    formData.append('sign',sign)
    formData.append('ets',ets)
    let res = await axios.post(global.BASE_URL + '/msi/base/acl/getCode',formData)
    if (res.data.code !== '0000') {
     throw new Error(`获取 code 失败: ${res.data.message}`);
    }
    let code = res.data.data
    delete paramsJson.token
    const remainingParams = new URLSearchParams(paramsJson).toString();
    return baseUrl + '?' + remainingParams+'&sign='+sign+'&ets='+ets+'&code='+code
}


// WEBPACK FOOTER //
// ./src/assets/common/redirectEncrypt.js